import * as Sentry from "@sentry/react";

export const ignoreErrors = [
	/ResizeObserver loop/i,
	/nexusWebSocket/i,
	/Failed to execute 'insertBefore' on 'Node':/i,
	"The object can not be found here.",
	"Unauthorized",
	"Cannot read properties of null (reading 'tabIndex')",
	"Action Forbidden",
	"Cannot read property 'init' of undefined",
	/Failed to execute 'removeChild' on 'Node'/i,
	/window.GRV2.init/i,
	"Invalid LatLng object: (undefined, undefined)",
	"Not found.",
	"Request failed with status code 401",
	"Cannot read properties of null (reading 'getLabelAndValue')",
	/(evaluating 'a.L')/i,
	"Cannot redefine property: plugins",
	"UnprocessableEntity",
	"Node.removeChild: The node to be removed is not a child of this node",
	/_._DumpException/i,
	"Invalid interval",
	"Action Forbidden",
	"BadRequest",
	/gCrWeb/i,
	"element is not defined",
	/Failed to read the 'contentDocument' property from 'HTMLIFrameElement':/i,
	"Can't find variable: structuredClone",
	"AbortController is not defined",
	"undefined is not an object (evaluating 't.pathname')",
	"Object.fromEntries is not a function",
	"Can't find variable: OnSavedResultCb",
	"The operation is insecure.",
	"Object captured as promise rejection with keys: data",
	"Non-Error promise rejection captured with value: Not implemented on this platform",
	"Cannot read properties of undefined (reading '_leaflet_pos')",
	"parent is null",
	"undefined is not an object (evaluating 's[e.responseRequestID].functions')",
	"Can't find variable: ResizeObserver",
	"Cannot read properties of null (reading 'endpoint')",
	"bb",
	"cb",
	"Cannot read properties of undefined (reading 'clearRect')",
	"Failed to fetch",
	"Load failed",
	"NetworkError when attempting to fetch resource.",
	"Network Error",
	"Unknown",
	"jb",
	"TooManyRequestsException",
	"BadRequestException",
	"UnprocessableEntity",
	"UnauthorizedException",
	"ForbiddenException",
	"NotFoundException",
	"NotAllowedException",
	"OrganizationAccessException",
	"out of memory",
	"undefined is not an object (evaluating 'this._ctx.clearRect')",
	/Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:update, ParamCount:\d+/i,
	/Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+/i,
	/Should not already be working\.?/,
	"Cannot read properties of null (reading 'shadowRoot')",
	"Open PDF in new window blocked by browser",
	"InvalidStateError: Cannot create payment request",
	"HTMLOUT is not defined",
	"Cannot read property 'tabIndex' of null",
	"null is not an object (evaluating 'this._logicalFormForControl(e).formElement')",
	"NS_ERROR_UNEXPECTED",
	"undefined is not an object (evaluating 'window.webkit.messageHandlers')",
	'can\'t access property "clearRect", this._ctx is undefined',
	"Invalid call to runtime.sendMessage(). Tab not found.",
	/__firefox__/i,
	/refresh_youtube/i,
	/ethereum\.selectedAddress/i,
];

export const beforeSend = (event: Sentry.ErrorEvent) => {
	const newEvent = { ...event };
	const eventBreadcrumbsIncludeStatus0 = newEvent.breadcrumbs?.some(
		(breadCrumb) => breadCrumb.data?.statusCode === 0
	);

	if (eventBreadcrumbsIncludeStatus0 && newEvent.exception && Array.isArray(newEvent.exception?.values)) {
		newEvent.exception.values = newEvent.exception.values.map((value) => ({
			...value,
			value: `${value.value} [ Request status 0 ]`,
		}));
	}

	const exception = newEvent?.exception?.values?.[0];
	const type = exception?.type || "";
	const mechanism = exception?.mechanism?.type || "";
	const frames = exception?.stacktrace?.frames || [];
	const userAgent = navigator.userAgent || "";

	const isUnhandledRejection = type === "UnhandledRejection" || mechanism === "onunhandledrejection";
	const hasNoRealStacktrace = !frames || frames.length <= 1;

	const valueStr = exception?.value || "";
	const isCustomLike = valueStr.includes("Non-Error promise rejection") || valueStr.includes("[object");

	if (isUnhandledRejection && hasNoRealStacktrace && isCustomLike) {
		return null;
	}

	const isGoogleAnalyticsError = event.exception?.values?.some((value) =>
		value.value?.includes("google-analytics.com")
	);

	if (isGoogleAnalyticsError) return null;

	const isDuckDuckGoBrowserError =
		event.message && event.message.includes("invalid origin") && userAgent.includes("DuckDuckGo");

	if (isDuckDuckGoBrowserError) return null;

	const allAnonymous = frames.every((f) => !f.filename || f.filename === "<anonymous>");
	const message = event.exception?.values?.[0]?.value || "";

	if (message.includes("Java object is gone") && allAnonymous) {
		return null;
	}

	return newEvent;
};
